import React, { Fragment } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  CardMedia,
  Grid,
  Divider,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import SEO from "../../components/ceo/CEO";

const ActivitiesDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activity = location.state;

  const formattedDate = format(new Date(activity.created), "MMMM d, yyyy");

  return (
    <Fragment>
      <SEO
        title={activity.title}
        description={activity.description}
        url={"https://shallafg.org/activities/details/"}
        image={activity.image}
      />
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          py: 8,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              color: "#FFFFFF",
              textShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
              mb: 4,
              letterSpacing: "0.05em",
            }}
          >
            {activity.title}
          </Typography>

          <Divider
            sx={{
              backgroundColor: "#A9C9EA",
              opacity: 0.7,
              height: "2px",
              width: "100px",
              mx: "auto",
              mb: 4,
            }}
          />

          <Grid container spacing={6} alignItems="flex-start">
            <Grid item xs={12} md={6}>
              <CardMedia
                component="img"
                image={activity.image}
                alt={activity.title}
                sx={{
                  borderRadius: "16px",
                  width: "100%",
                  height: "auto",
                  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.4)",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: "0.95rem",
                    color: "#A9C9EA",
                    fontWeight: 500,
                    mb: 2,
                  }}
                >
                  Created on: {formattedDate}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "#D1D5DB",
                    fontSize: "1.2rem",
                    lineHeight: 1.8,
                    mb: 4,
                  }}
                >
                  {activity.description}
                </Typography>

                <Button
                  variant="contained"
                  sx={{
                    alignSelf: "flex-start",
                    backgroundColor: "#10a7e0",
                    color: "#FFFFFF",
                    padding: "10px 24px",
                    fontSize: "1rem",
                    borderRadius: "8px",
                    textTransform: "uppercase",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#10a7e0",
                      boxShadow: "0 8px 24px rgba(0, 86, 179, 0.4)",
                      transform: "translateY(-2px)",
                    },
                  }}
                  onClick={() => navigate("/activities/")}
                >
                  Go Back
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
};

export default ActivitiesDetails;
